export default [
    {
        path: 'relatorio-estatistico-paciente-cadastrado',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-estatistico-paciente-cadastrado' */
            '@/views/atencao-basica/relatorio-estatistico-paciente-cadastrado/Index'
        ),
        redirect: 'relatorio-estatistico-paciente-cadastrado/index',
        children: [
            {
                name: 'atencao-basica-relatorio-estatistico-paciente-cadastrado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-estatistico-paciente-cadastrado' */
                    '@/views/atencao-basica/relatorio-estatistico-paciente-cadastrado/List.vue'
                ),
            },
        ],
    },
]
